module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 620
// module chunks = 0